import React, { useState, useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'

import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'

import { DatePicker } from '@material-ui/pickers'
import dayjs from 'dayjs'

import MessageEdit from '../MessageEdit'
import MessageCreate from '../MessageCreate'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

const useStyles = makeStyles(theme => ({
    root: {
        // maxWidth: '100% !important',
        backgroundColor: theme.palette.background.paper,
        overflow: 'auto',
        position: 'relative',
        maxHeight: '65vh',
    },
    inline: {
        display: 'inline',
    },
    datePicker: {
        marginTop: '15px',
        marginBottom: '15px',
        marginRight: '25px',
    },
    controlsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        // justifyContent: 'center',
        alignItems: 'center',
    },
    commentWrapper: {
        // paddingRight: '80px',
        cursor: 'pointer',
    },
    commentText: {
        maxHeight: '70px',
        // textOverflow: 'ellipsis',
        overflow: 'hidden',
        // whiteSpace: 'nowrap',
        textAlign: 'justify',
        paddingRight: '1em',
        position: 'relative',
        // cursor: 'pointer',

        '&::before': {
            content: "'...'",
            position: 'absolute',
            right: 0,
            bottom: 0,
        },

        '&::after': {
            content: "''",
            position: 'absolute',
            right: 0,
            // bottom: 0,
            width: '1em',
            height: '1em',
            background: theme.palette.background.paper,
            marginTop: '0.2em',
        },
    },
}))

export default function MessageList() {
    const [selectedDate, handleDateChange] = useState(dayjs())
    // const [commentEditState, setCommentEditState] = useState(false)
    const [selectedMessage, setSelectedMessage] = useState(null)
    const [messageForm, setMessageForm] = useState(false)

    const classes = useStyles()

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    useEffect(() => {
        if (firebaseContext.data.fetchingState.messages) {
            appContext.startLoading()
        } else {
            appContext.endLoading()
        }
    })

    useEffect(() => {
        firebaseContext.closeMessagesListener()

        const start = selectedDate.startOf('date').toDate()
        const end = selectedDate.endOf('date').toDate()
        firebaseContext.startMessagesListener(start, end)
        // firebaseContext.startRolesListener();

        return () => {
            firebaseContext.closeMessagesListener()
        }
    }, [selectedDate])

    const handleEdit = message => {
        setSelectedMessage(message)
    }

    // const toggleCommentEdit = () => {
    //     setCommentEditState(!commentEditState)
    // }

    const closeCommentEdit = () => {
        setSelectedMessage(null)
    }

    const handleCreate = () => {
        setMessageForm(true);
    }

    const handleCloseCreate = () => {
        setMessageForm(false);
    }

    const updateOldMessage = () => {
        firebaseContext.updateOldMessages()
    }

    const getLanguageRepresent = (languageId) => {
        const languageRepresent = languageList.filter(language => language.id === languageId).map(language => language.data.represent)
        return languageRepresent.join('')
    }

    const [languageList, setlanguageList] = useState([]);
    const getLanguagesList = () => firebaseContext.getLanguages().catch((e) => console.log('getLanguagesList: ', e));

    useEffect(() => {
        (() => {
            getLanguagesList()
                .then(languages => setlanguageList(languages))
        })();
    }, []);

    return (
        <>
            <div className={classes.controlsWrapper}>
                <DatePicker
                    disableFuture
                    // openTo="year"
                    format="DD/MM/YYYY"
                    label="Выберите день"
                    views={['year', 'month', 'date']}
                    value={selectedDate}
                    onChange={handleDateChange}
                    cancelLabel="Отмена"
                    className={classes.datePicker}
                />
                <Button variant="contained" onClick={handleCreate}>
                    Сообщение от администрации
                </Button>
                <Button variant="text" onClick={updateOldMessage}>
                    Проставить язык в старых сообщениях
                </Button>
            </div>
            <List className={classes.root}>
                {firebaseContext.data.messages.length === 0 ? (
                    <Typography variant="body1" key="key">
                        Нет сообщений за указанный период
                    </Typography>
                ) : (
                    firebaseContext.data.messages.map((comment, i) => (
                        <div key={comment.id}>
                            <ListItem
                                alignItems="flex-start"
                                className={classes.commentWrapper}
                                key={comment.id}
                                onClick={event => handleEdit(comment)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        alt="Remy Sharp"
                                        src={comment.data.photoURL}
                                    />
                                </ListItemAvatar>
                                <ListItemText>
                                    <Typography
                                        variant="h6"
                                        color="textPrimary"
                                    >
                                        {comment.data.userName}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        ID пользователя: {comment.data.userId}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        color="textPrimary"
                                        className={classes.commentText}
                                    >
                                        {comment.data.message}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        {dayjs(comment.data.dateTime).format(
                                            'DD/MM/YYYY HH:mm:ss'
                                        )}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        {getLanguageRepresent(comment.data.locale)}
                                    </Typography>
                                </ListItemText>
                                {/* <ListItemSecondaryAction>
                                    <IconButton edge="end">
                                        <EditIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            {/* {i !== firebaseContext.data.messages.length - 1 && (
                                <Divider variant="inset" component="li" />
                            )} */}
                        </div>
                    ))
                )}
            </List>
            {selectedMessage !== null && (
                <MessageEdit
                    open={true}
                    handleClose={closeCommentEdit}
                    message={selectedMessage}
                    languageList={languageList}
                />
            )}
            <MessageCreate
                open={messageForm}
                handleClose={handleCloseCreate}
                languageList={languageList}
            />
        </>
    )
}
